export function setStatusApproval(state, payload) {
  state.history = payload;
}
